import { Component, OnInit } from '@angular/core';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from "../helper/shared/shared.service";
import { Router, ActivatedRoute } from '@angular/router';
import { AuthGuardService } from "../helper/guards/auth-guard-service.service";
import { LoginService } from "./login.service";
import { UserInfoService } from "../user-info/user-info.service";
import { isNullOrUndefinedObject, isNullOrEmpty, isNullOrUndefined } from '../helper/validation';
import { ProgramSettingsService } from '../program-settings/program-settings.service'; //Modified by PP(2023-05-03) : Program Settings sometimes empty
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  faEye = faEye;
  faEyeSlash = faEyeSlash;

  email: string = "";
  password: string = "";
  loading: boolean = false;
  passwordflag: boolean = true;
  logincode: string = "";

  constructor(
    private router: Router,
    private activated: ActivatedRoute,
    private authGuard: AuthGuardService,
    private loginService: LoginService,
    private sharedService: SharedService,
    private toastr: ToastrService,
    private userInfoService: UserInfoService,
    public programSettingService: ProgramSettingsService //Modified by PP(2023-05-03) : Program Settings sometimes empty
  ) { }

  ngOnInit() {
    let cookiesfromCFSS = this.loginService.cookieSvc.get("CFSSLoginCode");

    //Modified by Pinky (2026-10-12) : Login from Central Station unable to come to mccld. Pinky open back - START
    if(!isNullOrEmpty(this.activated.snapshot.queryParams.AccessCode)){
      cookiesfromCFSS = this.activated.snapshot.queryParams.AccessCode;
      //Modified by JW(2024-12-12): set up-to-date token to cookies-start
      this.loginService.cookieSvc.set("CFSSLoginCode", cookiesfromCFSS); 
      this.sharedService.token = cookiesfromCFSS;
      //Modified by JW(2024-12-12): set up-to-date token to cookies-end
    }
    //Modified by Pinky (2026-10-12) : Login from Central Station unable to come to mccld. Pinky open back - END

    //Modified by PP(2023-10-24): Check for timeout of logincode - START
    if (cookiesfromCFSS !== '') {
      this.sharedService.checkValidLogin(cookiesfromCFSS).subscribe(res => {
        if (res === true) {
          this.authGuard.checkRemainingSec = true;
          this.router.navigate(["home"], { queryParams: { ApplicationID: this.sharedService.ApplicationID } });
        } else {
          this.toastr.error('Session time-out. Please login again.', '');
          this.sharedService.invalidLoginMessage = 'Session time-out. Please login again.';
          this.loginService.cookieSvc.set("CFSSLoginCode", '');
          cookiesfromCFSS = '';
          this.userInfoService.userData.UserId = 0;
          //this.router.navigate(["login"]);
        }
      });
    } else {
      if (this.email !== '' && this.password !== '') {
        this.login();
      }
    }
    //Modified by PP(2023-10-24): Check for timeout of logincode - END

    //Modified by Pinky (2026-10-12) : Login from Central Station unable to come to mccld. Pinky open back - START
    // if(!isNullOrEmpty(this.activated.snapshot.queryParams.AccessCode)){
    //   cookiesfromCFSS = this.activated.snapshot.queryParams.AccessCode;
    // }
    // if(cookiesfromCFSS !== '' ){
    //   this.authGuard.checkRemainingSec = true;
    //   this.router.navigate(["home"], { queryParams: { ApplicationID  : this.sharedService.ApplicationID}});
    // } else {
    //   if (this.email !== '' && this.password !== ''){
    //     this.login();
    //   }
    // }
    //Modified by Pinky (2026-10-12) : Login from Central Station unable to come to mccld. Pinky open back - END

  }

  togglepassword() {
    let text: any = document.getElementById("password");
    if (text.type === "password") {
      text.type = "text";
      this.passwordflag = false;
    } else {
      text.type = "password";
      this.passwordflag = true;
    }
  }

  // login(){
  //   this.loading = true;
  //   this.loginService.getUsers(this.email, this.password).subscribe((res) => {
  //     if (res !== undefined){
  //       let result: any = res;
  //       this.logincode = result.LoginCode;
  //       if(this.logincode !== '') {         
  //         let cldtoken = this.loginService.cookieSvc.get("CFSSLoginCode");
  //         if (cldtoken === '' || cldtoken === undefined) {
  //           this.loginService.cookieSvc.set("CFSSLoginCode", result.LoginCode);         
  //           this.sharedService.token = result.LoginCode;
  //           this.loginService.getAccessRight(result.LoginCode).subscribe((accesslist) => {        
  //             if (accesslist !== undefined && accesslist !== null){
  //               let dataList: any = accesslist;
  //               let foundAccess=false;
  //               for (let info of dataList) {
  //                 if ( info.ApplicationID === this.userInfoService.ApplicationID ) {
  //                   if (info.Approved === true) {
  //                     foundAccess= true;
  //                     break;
  //                   }
  //                 }
  //               }
  //               if(foundAccess){
  //                 let userId = this.userInfoService.userData.UserId;
  //                   if (userId === 0){
  //                     this.userInfoService.getUserAccountInfo(this.sharedService.token).subscribe(usrAccountInfo => {
  //                       if(usrAccountInfo !== undefined) {
  //                         this.sharedService.detectUserBrowser();
  //                         this.userInfoService.InsertUserData(usrAccountInfo);
  //                         this.getProgramSettingsDDL(usrAccountInfo); //Modified by PP(2023-05-03) : Program Settings sometimes empty
  //                         this.sharedService.RetrieveDDL();
  //                         console.log("PS20230321 Check: => Update App Usage - START=> "   + new Date());  
  //                         this.userInfoService.updateUserApplicationUsage(this.sharedService.token,'LOGON').subscribe(result => {
  //                           console.log("PS20230321 Check: => Update App Usage - END=> "   + new Date());   
  //                           if (result) {
  //                           }
  //                         });
  //                         this.validation(true,undefined);
  //                       }else{
  //                         this.validation(false,"connectionIssue");
  //                       }
  //                     });
  //                   }
  //               }else{
  //                 this.validation(false,"noAccess");
  //               }
  //             }else{
  //               this.validation(false,"noAccess");
  //             }
  //           });
  //         }

  //       } else {
  //         this.validation(false,"nologincode");
  //       }
  //     }
  //   });    
  // }

  login() {
    this.loading = true;
    this.loginService.getUsers(this.email, this.password).subscribe(
      (res) => {
        if (res === undefined) { this.validation(false, 'connectionIssue'); this.loading = false; return; }

        const result: any = res;
        this.logincode = (result.LoginCode || '').trim();

        if (this.logincode === '') {
          //Modified by Pinky(2026-10-05) : A clearer error message for invalid password #138221 - START
          //this.validation(false, 'nologincode'); 
          if (result.ErrorMessage != '') {
            this.validation(false, result.ErrorMessage);  
          } else {
              this.validation(false, 'nologincode');    
          }
          //Modified by Pinky(2026-10-05) : A clearer error message for invalid password #138221 - END
               
          //this.toastr.warning(res.ErrorMessage !== '' ? res.ErrorMessage : 'Login failed.'); //pplim 20260907: Improve login error message for invalid password
          this.loading = false;
          return;
        }

        // -validateTokenTime
        this.loginService.validateTokenTime(this.logincode).subscribe(
          (seconds: number) => {
            if (seconds <= 0) {
              this.validation(false, 'tokenExpired');
              this.loading = false;
              return;
            }

            // proceed with your existing flow
            const cldtoken = this.loginService.cookieSvc.get('CFSSLoginCode');
            if (cldtoken === '' || cldtoken === undefined) {
              this.loginService.cookieSvc.set('CFSSLoginCode', this.logincode);
            }
            this.sharedService.token = this.logincode;

            this.loginService.getAccessRight(this.logincode).subscribe(
              (accesslist) => {
                if (accesslist === undefined || accesslist === null) {
                  this.validation(false, 'noAccess');
                  this.loading = false;
                  return;
                }

                const dataList: any = accesslist;
                let foundAccess = false;
                for (let info of dataList) {
                  if (info.ApplicationID === this.userInfoService.ApplicationID && info.Approved === true) {
                    foundAccess = true; break;
                  }
                }

                if (!foundAccess) {
                  this.validation(false, 'noAccess');
                  this.loading = false;
                  return;
                }

                const userId = this.userInfoService.userData.UserId;
                if (userId === 0) {
                  this.userInfoService.getUserAccountInfo(this.sharedService.token).subscribe(
                    (usrAccountInfo) => {
                      if (usrAccountInfo === undefined) {
                        this.validation(false, 'connectionIssue');
                        this.loading = false;
                        return;
                      }

                      this.sharedService.detectUserBrowser();
                      this.userInfoService.InsertUserData(usrAccountInfo);
                      this.getProgramSettingsDDL(usrAccountInfo); // Modified by PP
                      this.sharedService.RetrieveDDL();

                      this.userInfoService
                        .updateUserApplicationUsage(this.sharedService.token, 'LOGON')
                        .subscribe(() => { }, () => { });

                      this.validation(true, undefined);
                      this.loading = false;
                    },
                    () => { this.validation(false, 'connectionIssue'); this.loading = false; }
                  );
                } else {
                  // already had userId, consider success or continue as needed
                  this.validation(true, undefined);
                  this.loading = false;
                }
              },
              () => { this.validation(false, 'connectionIssue'); this.loading = false; }
            );
          },
          () => { this.validation(false, 'connectionIssue'); this.loading = false; }
        );
      },
      () => { this.validation(false, 'connectionIssue'); this.loading = false; }
    );
  }


  validation(pass: boolean, action: any) {
    switch (pass) {
      case true:
        this.authGuard.checkRemainingSec = false;
        this.toastr.success("Logged In - Welcome!", "");
        this.loading = false;
        //this.sharedService.FetchContamination_FilterGrouping();      //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
        this.router.navigate(["home"]);
        break;
      case false:
        switch (action) {
          case "connectionIssue":
            this.toastr.error("Failed to called API. Please try login again.", "");
            this.loading = false;
            break;
          case "noAccess":
            this.toastr.error("You do not have access to this application. Kindly request an access at https://cfss.camfil.net/cfss", "");
            this.loading = false;
            break
          default:
            //Modified by Pinky(2026-10-05) : A clearer error message for invalid password #138221 this.toastr.error("Invalid Credentials", "");
            this.toastr.error(action, ""); //Modified by Pinky(2026-10-05) : A clearer error message for invalid password #138221
            this.loading = false;
            break;
        }
        break;
    }
    this.checkEnableMultiGasCalc(); //Modified by PP(2023-02-09) : To cater for not getting multi gas alrogrithm
  }

  //Modified by PP(2023-02-09) : To cater for not getting multi gas alrogrithm - START
  checkEnableMultiGasCalc() {
    this.sharedService.GetMultiGasCalcFlag().subscribe(res => {
      if (res === true) {
        this.sharedService.EnableMultiGasCalculation = true;
      } else {
        this.sharedService.EnableMultiGasCalculation = false;
      }
    });
  }
  //Modified by PP(2023-02-09) : To cater for not getting multi gas alrogrithm - END

  //Modified by PP(2023-05-03) : Program Settings sometimes empty - START
  getProgramSettingsDDL(pUserAccObj) {
    console.log("PS20230321 Check: => fetch program settings -START=> " + new Date());
    this.programSettingService.getData(pUserAccObj.UnitID).subscribe(
      res => {
        console.log("PS20230321 Check: => fetch program settings -END=> " + new Date());
        if (res !== undefined && res !== null) {
          this.programSettingService.unitList = res.Selection.UnitsList;
          this.programSettingService.formatList = res.Selection.FormatList;

          this.programSettingService.airFlowUnit_SI = res.Selection.FlowRateList_SI;
          this.programSettingService.airFlowUnit_US = res.Selection.FlowRateList_US;
          this.programSettingService.concUnit_SI = res.Selection.ConcentrationUnitList_SI;
          this.programSettingService.concUnit_US = res.Selection.ConcentrationUnitList_US;

          // switch(pUserAccObj.UnitID) {
          //   case 1:
          //     this.programSettingService.concUnitList = res.Selection.ConcentrationUnitList_SI.List;
          //     this.programSettingService.airFlowUnitList = res.Selection.FlowRateList_SI.List;
          //     break;
          //   case 2:
          //     this.programSettingService.concUnitList = res.Selection.ConcentrationUnitList_US.List;
          //     this.programSettingService.airFlowUnitList = res.Selection.FlowRateList_US.List;
          //     break;
          // }
        }
      },
      err => {

      }
    );
  }
  //Modified by PP(2023-05-03) : Program Settings sometimes empty - END

  //Modified by JW(2025-10-03): Azure DevOps #116276-start

  //Modified by JW(2025-10-03): Azure DevOps #116276-end
}
